<div class="circle-container">
  <div class="circle" [style]="getDeg()">
    <div *ngFor="let circle of this.circles; let i = index"
         class="dot"
         [class.dot-active]="i === active"
         [style]="getPositionCircle(circle)">
    </div>
    <div *ngFor="let continent of this.continents"
         class="continent"
         [class]="{
      'continent-active': continent.id == active,
      'continent-none': isNoneContinent(continent.id),
     }"
         [class.hovered]="continent.isHovered"
         [style]="getPositionContinent(continent)"
         (mouseenter)="enterContinent(continent)"
         (mouseleave)="leaveContinent(continent)"
         (click)="clickContinent(continent)"
    >
      <img [src]="getSvg(continent)" [alt]="continent.icon?.src" [style]="getOpacity(continent.isHovered)">
      <h5 [class]="continent.id == active ? 'figma-text-title' : 'figma-text-subtitle'">
        <app-texts
          [texts]="[
            {text: continent.title}
          ]"
        />
      </h5>
    </div>
  </div>
  <div class="circle-arrows-container" [ngClass]="{'clockwise': clockwise, 'counterclockwise': !clockwise}">
    <div class="circle-arrows">
      <div *ngFor="let circleVail of this.circlesVail"
           class="circle-veil"
           [style]="getPositionCircleVail(circleVail)"
      >
        <app-icon [icon]="Icons.circleArrows"/>
      </div>
    </div>
  </div>
</div>
